import React, {useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { IoMdClose } from 'react-icons/io';
import './style.css';

const FeatureTile = ({ featured }) => {
    console.log("Loading featured");
    const { heading, image, links, fontColor, description, backgroundColor } = featured;
    const [isOpen, setIsOpen] = useState(true);

    if (featured.isDisplayed && isOpen) {
        return <div className='common__featuredTile' style={{
            color: fontColor,
            backgroundImage: `url(${process.env.REACT_APP_API_DOMAIN + image.url})`,
        }}>
            <div className='flex flex-col justify-center p-4 xl:p-8'>
                <div className='absolute inset-0 -z-10 opacity-30 lg:opacity-60' style={{
                    backgroundColor
                }}></div>
                <button aria-label='Close' className='self-end' onClick={() => setIsOpen(false)}><IoMdClose className='icon'></IoMdClose></button>
                <div className='stack-l' style={{
                    "--space": "var(--s2)"
                }}>
                    <h3>{heading}</h3>
                    <ReactMarkdown>{description}</ReactMarkdown>
                    {links.length !== 0 && <div className="cluster-l">
                        {links.map(({ displayText, url }, i) => <a key={i} className='btn btn-primary uppercase' href={url}>{displayText}</a>)}
                    </div>}
                </div>
            </div>

        </div>
    } else {
        return null;
    }
}

export default FeatureTile;